<!-- 
Sign-in page.
Users sign in using PRISMS credentials.
-->
<template>
  <v-container>
    <v-layout>
      <v-flex 
        xs12 
        sm10 offset-sm1 
        md8 offset-md2 
        lg6 offset-lg3
        xl4 offset-xl4
      >
        <div class="text-xs-center mb-3 pt-4">
          <img src="@/assets/aus-govt-logo-centered.png" alt="Australian Government" height="150px">
        </div>
        <h1 class="text-xs-center display-1 mb-3 mt-2">Levies Tuition Protection Service {{ environment }}</h1>
        <p class="mb-3">
          This site provides administration functions for the <i>Levies Tuition Protection Service</i>.
          It is for use by authorised governmental staff only. Penalties apply for unauthorised access.
        </p>
        <sign-in-panel />
        <disclaimer-copyright-and-privacy-links />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import SignInPanel from "@/components/users/SignInPanel.vue";
import DisclaimerCopyrightAndPrivacyLinks from "@/components/system/DisclaimerCopyrightAndPrivacyLinks.vue";

export default {
  name: "SignIn",
  components: { SignInPanel, DisclaimerCopyrightAndPrivacyLinks },
  computed: {
    environment() {
      return this.$store.getters.environmentForToolbar;
    }
  }
};
</script>
